<template>
  <div>
    <vue-autosuggest
      v-model="STOCK"
      style="width: 100%"
      :suggestions="filteredOptions2"
      :get-suggestion-value="getSuggestionValue2"
      :input-props="{
        id: 'autosuggest__input',
        class: 'form-control'
      }"
      @input="onInputChange"
    >
      <template slot-scope="{ suggestion }">
        <div class="d-flex align-items-center my-suggestion-item ">
          <div class="detail ml-50 my-suggestion-item">
            <b-card-text class="mb-0">
              {{ suggestion.item.STOCKNAME.trim() }}/
              {{ suggestion.item.STOCKNO.trim() }}
            </b-card-text>
          </div>
        </div>
      </template>
    </vue-autosuggest>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
export default {
  data() {
    return {
      filteredOptions2: [],
      STOCK: "",
      query: "",
      filteredOptions: [],
      data: "",
      STOCKID: "",
      ACTSTOCKGROUP: "",
      STOCKNAME: "",
      stokListesi: []
    };
  },
  created() {
    this.setData(this.params.value === "Happy");
    this.query = this.params.data.STOCKNAME;
    this.setData(this.query);
    //this.$store.commit("account/SATINALMA_STOCKID", this.params.data.STOCKID);
  },
  methods: {
    getValue() {
      return this.data;
    },
    setData(data) {
      this.data = data;
    },
    getSuggestionValue2(suggestion, upd) {
      this.STOCKNAME = suggestion.item.STOCKNAME;
      this.STOCKID = suggestion.item.STOCKID;
      //   this.ACTSTOCKGROUP = suggestion.item.GROUPCODE;

      var cari = {
        STOCKNAME: this.STOCKNAME,
        STOCKID: this.STOCKID
      };
      this.setData(this.STOCKNAME);
      this.$store.commit("account/SATINALMA_CARI", this.STOCKID);
      this.$root.$emit(
        "setStokValue",
        this.params.rowIndex,
        suggestion.item,
        this.params.data.STOCKID,
        this.params.data.GROUPCODE
      );

      //this.params.api.stopEditing();

      // if(suggestion)
      //   this.isDisabled = false;
      return suggestion.item.STOCKNAME;
    },

    onInputChange(text) {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");

      const args = {
        COMPANYID: state.MusteriId,
        ARANAN: vm.STOCK,
        ISLEM: "LIST",
        token: Store.state.tokenId,
        ANASTOCKID: vm.$store.state.uzum.mpstockstokcid
      };
      soap.createClient(url, function(err, client) {
        client.STOCK(args, function(err, result) {
          if (result.STOCKResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.STOCKResult);
          vm.stokListesi = JSON.parse(vm.veriler.jsonData);

          vm.filteredOptions2 = [
            {
              data: vm.stokListesi.filter(option => {
                return (
                  option.STOCKNAME.toUpperCase().indexOf(
                    vm.STOCK.toUpperCase()
                  ) > -1
                );
              })
            }
          ];
        });
      });
    }
  }
};
</script>
<style lang="scss">
[dir="ltr"] .autosuggest__results {
  height: 160px !important;
}
.vs__dropdown-menu {
  height: 160px !important;
}
</style>
